



























import Vue from 'vue';
import API from '@/api/common';
import NOC from '@/class/common/const';
import { ReferenceOperationCountInfo } from '@/class/models/typed/operation';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

interface IDataCaptionSet {
  caption: string;
  captionSP: string; // スマホ用
  src: string;
  srcSP: string; // スマホ用
}

interface IDataTable {
  border: boolean;
  th: string[];
  td: string[][];
}

interface IAnaliticsDataTable extends IDataCaptionSet {
  heading: string;
  table: IDataTable;
}

interface Data {
  setTitleData: string;
  setAnaliticsDataTable: IAnaliticsDataTable;
  answerOpen: boolean;
  analysisDatas: ReferenceOperationCountInfo[];
  viewAnalysisDatas: string[][];
}

interface Methods {
  fetchAnalysisDatas: () => void;
}

interface Computed {
  AnaliticsDataTable: IAnaliticsDataTable[];
}

interface Props {
  article: string;
}


export default Vue.extend({
  name: 'DebugHome',
  data() {
    return {
      setTitleData: '',
      answerOpen: false,
      analysisDatas: [] as ReferenceOperationCountInfo[],
      viewAnalysisDatas: [] as string[][],
    };
  },
  computed: {
    setAnaliticsDataTable() {
      return(
        {
          heading: '・実労働時間の算出方法',
          caption: '15分間で、ユーザーの職種ごとに定められた基準操作回数(キー入力数＋マウス操作回数)を達成すると「15分間勤務した」と判定される仕組みとなっています。\n職種ごとに必要な基準操作回数は以下の通りです。\nまた、基準操作回数はシステム全体の操作回数をもとに計算され、月初に更新されることがあります。\n\n',
          table: {
            border: true,
            th: ['職種', '基準操作回数'],
            td: this.viewAnalysisDatas,
          },
        });
    },
  },
  props: {
    article: String,
  },
  watch: {
    // analysisDatasからviewAnalysisDatasを生成
    analysisDatas(data: ReferenceOperationCountInfo[]) {
      const jobMap = new Map(NOC.JOB.JOBArray.map(({ value, text }) => [value, text]));
      this.viewAnalysisDatas = data.map((item) => [
        jobMap.get(item.job) || 'noData',
        String(item.reference_op_count + '回'),
      ]);
    },
  },
  async mounted() {
    await this.fetchAnalysisDatas();
  },
  methods: {
    // 全国の操作回数の統計情報を取得
    async fetchAnalysisDatas() {
      const api = new API();
      const res = await api.get('operation/reference_counts');
      this.analysisDatas = res.data as ReferenceOperationCountInfo[];
    },
    // 基準操作回数の設定テスト
    async updateReferenceOpCountSettingsTest(){
      const api = new API();
      let ref_op_count_infos :ReferenceOperationCountInfo[] = [
        { job: NOC.JOB.VALUE.DEFAULT, reference_op_count: 12 },
        { job: NOC.JOB.VALUE.BILL, reference_op_count: 13 },
      ];
      const res = await api.post('operation/reference_counts', ref_op_count_infos);
      console.log("post operation/reference_counts res=", res);
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);

